import { render, staticRenderFns } from "./bomItemDialog.vue?vue&type=template&id=496cc792&scoped=true"
import script from "./bomItemDialog.vue?vue&type=script&lang=js"
export * from "./bomItemDialog.vue?vue&type=script&lang=js"
import style0 from "./bomItemDialog.vue?vue&type=style&index=0&id=496cc792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496cc792",
  null
  
)

export default component.exports